/* eslint-disable no-unused-vars */
import api from '../../services/index'
import Chart from 'chart.js'

export default {
  data () {
    return {
      data_one: [],
      data_two: [],
      data_question: [],
      data_filter: [],
      handler: {},
      data_two_donut: [],
      data_two_donut_total: 100000,
      modal_data_user: [],
      modal_campus: null,
      modal_fac: null,
      modal_depart: null,
      modal_major: null,
      modal_count_user: 0,
      campus_list: [],
      fac_list: [],
      depart_list: [],
      major_list: [],
      myChart: null,
      myChart2: null,
      modal_select_choice: null
    }
  },
  methods: {
    getData () {
      var obj = {
        'campus': '',
        'faculty': '',
        'depart': '',
        'major': ''
      }
      api.DataStudent(
        obj,
        result => {
          if (result.result === true) {
            this.data_one = result.data
            this.data_two = result.dataTwo
            this.data_filter = result.filter
            this.data_question = result.data_question
            this.getChartOne()
            this.getChartTwo()
          } else {
            this.alert_msg('warning', 'แจ้งเตือน', result.message)
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    getChartOne () {
      this.data_one.forEach(val => {
        val['sections'] = [
          { label: 'ผู้ประเมิน', value: val['answer'], color: '#5f76e8', status: true, campus: val['id'] },
          { label: 'นักศึกษาทั้งหมด', value: val['std'], color: '#cfcfcf', status: false, campus: val['id'] }
        ]
      })
    },
    handleSectionClick (section, event) {
      if (section.status === true) {
        // this.alert_msg('warning', 'แจ้งเตือน', 'กำลังพัฒนาอยู่นะครับ')
        // alert(`${section.campus} clicked.`)
        this.campus_list.forEach(v => {
          if (v['campus_id_pri'] === section.campus) {
            this.modal_campus = v
          }
        })
        this.getModalUser()
        $('#countUserModal').modal('show')
      }
    },
    getChartTwo () {
      const color = [
        '#0c9c29',
        '#5f76e8',
        '#ff4f70',
        '#01caf1',
        '#ffe100']
      this.data_question.forEach(v => {
        var i = 0
        v['data_two_donut'] = []
        v['data_two_donut_total'] = 0
        v['data'].forEach(val => {
          v['data_two_donut_total'] += val['answer']
          v['data_two_donut'].push({ label: val['name'], value: val['answer'], color: color[i] })
          i++
        })
      })
    },
    renderCountUser () {
      var La = []
      var dataPoint = []
      this.modal_count_user = 0
      this.modal_data_user.forEach(val => {
        La.push(val['name'])
        dataPoint.push(val['answer'])
        this.modal_count_user += val['answer']
      })
      this.myChart.data.labels = La
      this.myChart.data.datasets[0].data = dataPoint
      this.myChart.update()
    },
    getCampus () {
      api.getCampus(
        res => {
          if (res.result === true) {
            this.campus_list = res.data
            this.modal_campus = this.campus_list[0]
          } else {
            this.campus_list = []
            this.alert_msg('warning', 'แจ้งเตือน', res.message)
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    getFaculty () {
      this.modal_fac = null
      api.getFaculty(
        res => {
          if (res.result === true) {
            this.fac_list = res.data
          } else {
            this.fac_list = []
            this.alert_msg('warning', 'แจ้งเตือน', res.message)
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    getDepartment () {
      var fac = null
      if (this.modal_fac !== null) {
        fac = this.modal_fac.faculty_id_pri
      }
      this.modal_depart = null
      api.getDepartment(
        fac,
        res => {
          if (res.result === true) {
            this.depart_list = res.data
          } else {
            this.depart_list = []
            this.alert_msg('warning', 'แจ้งเตือน', res.message)
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    getMajor () {
      var depart = null
      if (this.modal_depart !== null) {
        depart = this.modal_depart.department_id_pri
      }
      this.modal_major = null
      api.getMajor(
        depart,
        res => {
          if (res.result === true) {
            this.major_list = res.data
          } else {
            this.major_list = []
            this.alert_msg('warning', 'แจ้งเตือน', res.message)
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    getModalUser () {
      var obj = {
        'campus': (this.modal_campus) ? this.modal_campus.campus_id_pri : '',
        'faculty': (this.modal_fac) ? this.modal_fac.faculty_id_pri : '',
        'depart': (this.modal_depart) ? this.modal_depart.department_id_pri : '',
        'major': (this.modal_major) ? this.modal_major.major_id_pri : ''
      }
      api.DataStudent(
        obj,
        result => {
          if (result.result === true) {
            this.modal_data_user = result.data
            this.renderCountUser()
          } else {
            this.alert_msg('warning', 'แจ้งเตือน', result.message)
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    setChart () {
      var ctx = document.getElementById('my-chart')
      this.myChart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: '#6E7EF5',
            fill: false
          }]
        },
        options: {
          responsive: true,
          legend: {
            display: false
          }
        }
      })

      var ctx2 = document.getElementById('my-chart2')
      this.myChart2 = new Chart(ctx2, {
        type: 'horizontalBar',
        data: {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: '#6E7EF5',
            fill: false
          }]
        },
        options: {
          responsive: true,
          legend: {
            display: false
          }
        }
      })
    },
    selectChoice (ch) {
      this.modal_select_choice = ch
      this.modal_campus = null
      this.getDataChoice()
    },
    getDataChoice () {
      var obj = {
        'quest_id': this.modal_select_choice.quest_id,
        'answer_choice_id': this.modal_select_choice.id,
        'campus': (this.modal_campus) ? this.modal_campus.campus_id_pri : '',
        'faculty': (this.modal_fac) ? this.modal_fac.faculty_id_pri : '',
        'depart': (this.modal_depart) ? this.modal_depart.department_id_pri : '',
        'major': (this.modal_major) ? this.modal_major.major_id_pri : ''
      }
      api.DataChoice(
        obj,
        result => {
          if (result.result === true) {
            var La = []
            var dataPoint = []
            this.modal_count_user = 0
            result.data.forEach(val => {
              La.push(val['name'])
              dataPoint.push(val['answer'])
              this.modal_count_user += val['answer']
            })
            this.myChart2.data.labels = La
            this.myChart2.data.datasets[0].data = dataPoint
            this.myChart2.update()
          } else {
            this.alert_msg('warning', 'แจ้งเตือน', result.message)
            this.myChart2.data.labels = []
            this.myChart2.data.datasets[0].data = []
            this.myChart2.update()
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.getData()
    this.getCampus()
    this.getFaculty()
    this.getDepartment()
    this.getMajor()
    this.setChart()
    $('body').on('hidden.bs.modal', '.modal', function () {
      this.modal_campus = null
      this.modal_fac = null
      this.modal_depart = null
      this.modal_major = null
      this.modal_select_choice = null
      this.modal_count_user = 0
      $(this).removeData('bs.modal')
    }.bind(this))
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/student.js